import { request } from './api';
import config from '../config/index';
const _AppId = 'dealer.vr';
const videoApi = {
  /**
   * 获取视频列表
   */
  getVideoList({ dealerId, videoType, pageIndex, pageSize }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: `${config.dealerCloudVrapi}/vrapi/video/videoList`,
      data: {
        _appId: _AppId,
        dealerId,
        videoType,
        pageIndex,
        pageSize,
      },
    });
  },
  /**
   * 根据车型id获取视频相关信息
   * 18 奥迪A6L  54195
   * 146 奥迪A8  58757  56426
   * @param {*} param0
   * @returns
   */
  getVideoBySpecId({ specId }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: `${config.dealerCloudVrapi}/vrapi/car/plVideoList`,
      data: {
        _appId: _AppId,
        specId: specId,
      },
    }).then((result) => {
      if (result && result.length > 0) {
        let ptids = new Set(result.map((p) => p.ptid));
        let result2 = [];
        ptids.forEach((p) => {
          let item = result.find((q) => q.ptid === p);
          if (item) {
            result2.push(item);
          }
        });
        return result2;
      }
      return result;
    });
  },
};
export default videoApi;
